import React from 'react';
import { COLORS, Color } from '../../styles/variables';

interface ArrowDownIconProps {
  size?: number;
  color?: Color;
}

const ArrowDownIcon: React.FC<ArrowDownIconProps> = ({ color = COLORS.black, size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7 10L12.5 15.5 18 10" stroke={color} strokeWidth="1" fill="none" fillRule="evenodd" />
  </svg>
);

export default ArrowDownIcon;
